import SingleLoanCriteria from './SingleLoanCriteria';

export default SingleLoanCriteria;
